import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function ScarcityBar({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const dark = tone === 'dark';
  return <div className={`mx-auto w-full max-w-md rounded-2xl border p-4 ${dark ? 'border-white/20 bg-white/10' : 'border-gold/40 bg-[#FFF7E6]'}`} data-id="element-225" data-mp="2l4xsuu6708lr">
      <p className={`flex items-start gap-2 text-[13px] font-bold leading-snug sm:text-sm ${dark ? 'text-white' : 'text-ink'}`} data-id="element-226" data-mp="2q26dr2iq6qqp">
        <AlertTriangleIcon className={`mt-[2px] h-4 w-4 shrink-0 ${dark ? 'text-gold' : 'text-gold'}`} aria-hidden="true" data-id="element-227" data-mp="2g6399q0eig0l" />
        Restano solo 9 accessi al prezzo promozionale
      </p>
      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${dark ? 'bg-white/20' : 'bg-white'} ${dark ? '' : 'border border-gold/30'}`} data-id="element-228" data-mp="275y5rqybw1rp">
        <div className="h-full rounded-full bg-danger" style={{
        width: '91%'
      }} role="progressbar" aria-valuenow={91} aria-valuemin={0} aria-valuemax={100} aria-label="Accessi promozionali già richiesti" data-id="element-229" data-mp="5e1r48gv6bsp" />
      </div>
      <p className={`mt-2 text-[12px] font-semibold ${dark ? 'text-white/80' : 'text-inksoft'}`} data-id="element-230" data-mp="3dcy0cl5por4l">
        91% degli accessi promozionali già richiesti
      </p>
    </div>;
}